// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSurchargeCard_root__KIQjr","text":"PlasmicSurchargeCard_text__1cr5j"};